import React, { Component, useEffect, useState } from "react";
import { URL, draggable } from "../../utils/Constants";
import flashCardDefaultPic from "../../assets/images/flashCardDefault2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import CreateNewFlashCard from "./CreateNewFlashCard";
import CardTemplate from "./CardTemplate";
import {
  displayConfirmDeleteAlert,
  MESSAGEHEADER,
} from "../../utils/DisplayMessage";
import swal from "sweetalert";
import { axiosPost } from "../../utils/AxiosApi";

const UpdateFlashCards = ({
  codeIdx,
  selectedCard,
  getMyFlashCardsUpdate,
  setSelectedCard,
  handleUpdateFlashCardModal,
}) => {
  const [flashCards, setFlashCards] = useState([]);

  const handleCardThumbError = (e) => {
    return (e.target.src = flashCardDefaultPic);
  };

  const handleDeleteFlashCard = (id, idx) => {
    displayConfirmDeleteAlert({ id, idx }, deleteFlashCard);
  };

  const deleteFlashCard = (data) => {
    if (selectedCard.flashCards.length === 1 || flashCards?.length === 1) {
      swal({
        title: "Oops",
        text: "There should atleast be one flash card",
        closeOnClickOutside: false,
        allowOutsideClick: false,
      });
      draggable();
      return false;
    }
    const param = {
      id: data.id,
      flashCardSetId: selectedCard.id,
    };
    axiosPost(URL.deleteFlashCards, param, (response) => {
      if (response.status === 200) {
        getMyFlashCardsUpdate();
      }
    });
  };

  const removeFlashCard = (e, idx) => {
    const updatedFlashCards = [...flashCards];
    if (updatedFlashCards.length === 1) {
      swal({
        title: "Oops",
        text: "Atleast 1 flash card should be there",
        closeOnClickOutside: false,
        allowOutsideClick: false,
      });
      draggable();
    } else {
      updatedFlashCards.splice(idx, 1);
    }
    setFlashCards(updatedFlashCards);
  };

  const removeImage = (e, idx) => {
    const updatedFlashCards = [...flashCards];
    updatedFlashCards[idx]["image"] = "";
    updatedFlashCards[idx]["imagesId"] = "";
    updatedFlashCards[idx]["imageName"] = "";
    updatedFlashCards[idx]["imagePreview"] = "";
    setFlashCards(updatedFlashCards);
  };

  const handleImageChange = (e, idx) => {
    const name = e.target.name;
    const updatedFlashCards = [...flashCards];

    updatedFlashCards[idx][name] = e.target.files[0];
    updatedFlashCards[idx]["imageName"] = "";
    updatedFlashCards[idx]["imagesId"] = null;

    const image = window.URL.createObjectURL(updatedFlashCards[idx][name]);
    updatedFlashCards[idx]["imagePreview"] = image;
    setFlashCards(updatedFlashCards);
  };

  const handleFlashCardChange = (e, idx) => {
    const { name, value } = e.target;

    const updatedFlashCards = [...flashCards];
    updatedFlashCards[idx][name] = value;

    setFlashCards(updatedFlashCards);
  };

  const addFlashCard = (e) => {
    e.preventDefault();
    const updatedFlashCards = [...flashCards];
    updatedFlashCards.push({
      image: null,
      question: "",
      answer: "",
      hint: "",
      imagePreview: null,
    });
    setFlashCards(updatedFlashCards);
  };

  const handleSubmit = () => {
    const updatedFlashCards = [...flashCards];
    let error = [];
    updatedFlashCards.forEach((fCard, idx) => {
      if (!fCard?.image && !fCard?.imageName) {
        error.push("Image cannot be empty");
      }
      if (fCard?.question === "" || fCard?.answer === "") {
        error.push("Question and answer cannot be empty");
      }
    });
    if (error?.length > 0) {
      swal({
        title: MESSAGEHEADER.error,
        text: error[0],
        closeOnClickOutside: false,
        allowOutsideClick: false,
      });
      draggable();
      return false;
    } else {
      const formData = new FormData();
      const filesDetails = [];
      let cIdx = codeIdx + 1;

      updatedFlashCards.forEach((flashCard, idx) => {
        flashCard.code = "Flash-Card" + cIdx;
        if (flashCard.imageName && !flashCard?.image) {
          cIdx++;
        }
        if (flashCard.image != null) {
          formData.append("files", flashCard.image);
          filesDetails.push({
            code: flashCard.code,
          });
          cIdx++;
        }
        delete flashCard.image;
        delete flashCard.imagePreview;
      });
      formData.append("filesDetails", JSON.stringify(filesDetails));
      const flashCardSet = {
        id: selectedCard.id,
        flashCards: updatedFlashCards,
      };
      formData.append("flashCardSet", JSON.stringify(flashCardSet));

      axiosPost(
        URL.updateFlashCards,
        formData,
        (response) => {
          if (response.status === 200) {
            swal({
              title: MESSAGEHEADER.success,
              text: "Flash card updated successfully",
              closeOnClickOutside: false,
              allowOutsideClick: false,
            });
            draggable();
            getMyFlashCardsUpdate();
          }
        },
        (error) => {
          let errorResponse = error.response ? error.response.data : error;
          if (errorResponse.status === 400) {
            //if condition to check spring boot validation errors
            let errorMessage = "";
            if (errorResponse.errors) {
              errorResponse.errors.forEach((error) => {
                errorMessage += `${error.field
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, function (str) {
                    return str.toUpperCase();
                  })} ${error.defaultMessage} \n`; //ishan
              });
              swal(errorResponse.error, errorMessage, "");
            } else {
              swal(errorResponse.error, errorResponse.message, "");
            }
          } else {
            swal(
              errorResponse.error || "Network Error",
              errorResponse.message
                ? errorResponse.message
                : "Could Not Connect To The Server.",
              "",
            );
          }
        },
      );
    }
  };

  useEffect(() => {
    if (!selectedCard) return;

    setFlashCards([...selectedCard.flashCards]);
  }, [selectedCard?.flashCards]);

  return (
    <div style={{ height: "86.9vh" }}>
      <div style={{ height: "calc(100% - 50px)", overflowY: "auto" }}>
        <div
          style={{
            display: "flex",
            gap: "40px",
            flexWrap: "wrap",
            marginBottom: "24px",
          }}
        >
          {flashCards?.length > 0
            ? flashCards.map((cards, idx) => {
                return (
                  <>
                    <CardTemplate
                      id={cards?.id}
                      key={idx}
                      index={idx}
                      imagePreview={cards?.imagePreview}
                      imageName={cards?.imageName}
                      question={cards?.question}
                      answer={cards?.answer}
                      hint={cards?.hint}
                      removeImage={removeImage}
                      removeFlashCard={removeFlashCard}
                      handleImageChange={handleImageChange}
                      handleFlashCardChange={handleFlashCardChange}
                      handleDeleteFlashCard={handleDeleteFlashCard}
                    />
                  </>
                );
              })
            : "No cards available"}

          <div
            style={{
              backgroundColor: "#fff",
              display: "grid",
              placeContent: "center",
            }}
            className="flash-card-container"
            onClick={addFlashCard}
          >
            <FontAwesomeIcon color="#2877a4" icon={faPlus} size="2x" />
          </div>
        </div>
      </div>
      <div className="button-bg-color pr-4">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "end",
          }}
          className="col-12 text-right"
        >
          <button
            style={{ padding: "8px 14px" }}
            className="grayOutline-btn"
            onClick={handleUpdateFlashCardModal}
          >
            Cancel
          </button>
          <button
            style={{ padding: "8px 14px" }}
            className="primary-btn"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateFlashCards;
